import React from "react";
import clsx from "clsx";
import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from '@mui/styles';
import CircularProgress from "@mui/material/CircularProgress";
import { red, green } from "@mui/material/colors";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      alignItems: "center",
      float: "left",
      marginTop: theme.spacing(0),
      marginRight: theme.spacing(1),
      position: "relative",
    },
    buttonFail: {
      color: "white",
      //   backgroundColor: red[500],
      //   "&:hover": {
      //     backgroundColor: red[700],
      //   },
    },
    buttonSuccess: {
      color: "white",
      backgroundColor: green[500],
      "&:hover": {
        backgroundColor: green[700],
      },
    },
    fabProgress: {
      color: green[500],
      position: "absolute",
      top: -6,
      left: -6,
      zIndex: 1,
    },
    buttonProgress: {
      color: green[500],
      position: "absolute",
      top: "50%",
      left: "50%",
      marginTop: -12,
      marginLeft: -12,
    },
    disabled: {
      pointerEvents: "none"
    },
    iconFailure: {
      color: red[500],
      position: "absolute",
      top: "50%",
      left: "50%",
      marginTop: -12,
      marginLeft: -12,
      fontSize: 24,
    },
  })
);

export enum LoadingStatus {
  Initial,
  Loading,
  Success,
  Error,
}

export interface CircularProps {
  id?: any;
  settingsKey?: string;
  title: string;
  variant?: any;
  style?: any;
  disabled?: boolean;
  icon?: React.ReactNode;
  status: LoadingStatus;
  tooltip?: string;
  loadFn: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export default function CircularIntegration(props: CircularProps) {
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [tooltipIsOpen, setTooltipIsOpen] = React.useState(false);
  const buttonClassname = clsx({
    [classes.buttonSuccess]: props.status === LoadingStatus.Success,
    [classes.buttonFail]: props.status === LoadingStatus.Error,
  });


  const handleButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setTooltipIsOpen(false);
    if (props.status !== LoadingStatus.Loading) {
      props.loadFn(e);
    }
  };

  const wrapOptionalTooltip = (children: any) => {
    if (props.tooltip)
      return <Tooltip id={props.id} 
              title={props.tooltip} 
              open={tooltipIsOpen}
              onOpen={() => setTooltipIsOpen(true)}
              onClose={() => setTooltipIsOpen(false)}
              >
                {children}
             </Tooltip>;
   
      return <div>{children}</div>;
  };
  if(props.settingsKey) {
    const isLoading = props.status === LoadingStatus.Loading;
    return (
      <div className={classes.root}>
        {wrapOptionalTooltip(
          <Button
            id={props.id}
            variant={props.variant}
            style={props.style}
            className={isLoading ? classes.disabled : ""}
            disabled={
              props.status === LoadingStatus.Loading ||
              // props.status === LoadingStatus.Error ||
              props.disabled
            }
            onMouseEnter={() => { setTooltipIsOpen(false) ; setTooltipIsOpen(true) }}
            onMouseLeave={() =>  setTooltipIsOpen(false)}
            onClick={(e) => handleButtonClick(e)}
          >
            {props.icon}
          </Button>
        )}
  
        {props.status === LoadingStatus.Loading && (
          <CircularProgress id={props.id} size={24} className={classes.buttonProgress} thickness={4.5} disableShrink />
        )}
        {props.status === LoadingStatus.Error && (
          <RemoveCircleOutlineIcon className={classes.iconFailure} />
        )}
      </div>
    );
  } else {
  return (
    <div className={classes.root}>
      {wrapOptionalTooltip(
        <Button
          variant="outlined"
          size="large"
          startIcon={props.icon}
          className={buttonClassname}
          disabled={
            props.status === LoadingStatus.Loading ||
            props.status === LoadingStatus.Error ||
            props.disabled
          }
          onMouseEnter={() => { setTooltipIsOpen(false) ; setTooltipIsOpen(true) }}
          onMouseLeave={() =>  setTooltipIsOpen(false)}
          onClick={(e) => handleButtonClick(e)}
        >
          { props.title }
        </Button>
      )}

      {props.status === LoadingStatus.Loading && (
        <CircularProgress id={props.id} size={24} className={classes.buttonProgress} />
      )}
      {props.status === LoadingStatus.Error && (
        <RemoveCircleOutlineIcon className={classes.iconFailure} />
      )}
    </div>
  );
      }
}
